import type { CityConfig } from "../city-template/types";

export const centrevilleVaConfig: CityConfig = {
  city: "Centreville",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "centreville-va",
  route: "/cities/centreville-va",
  title: "Emergency Passport Centreville VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Centreville, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Centreville, Chantilly, Clifton, and Fairfax County. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Centreville, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Centreville, Chantilly, or Clifton? We help Fairfax County travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Centreville%20Virginia%20suburban%20landscape%20with%20modern%20residential%20neighborhoods%20and%20community%20parks%2C%20the%20historic%20Centreville%20area%20with%20Bull%20Run%20Regional%20Park%20and%20the%20Cub%20Run%20Stream%20Valley%20nearby%2C%20the%20Fair%20Lakes%20and%20Sully%20District%20shopping%20areas%2C%20Northern%20Virginia%20Fairfax%20County%20suburban%20community%20with%20green%20tree-lined%20streets%20and%20modern%20homes%2C%20warm%20afternoon%20light%20with%20rolling%20Piedmont%20terrain%2C%20professional%20photography%20showcasing%20suburban%20Virginia%20community%20with%20modern%20development%20and%20natural%20beauty%2C%20no%20people%20visible%2C%20scenic%20landscape%20with%20suburban%20homes%20and%20green%20foliage%20backdrop&width=1800&height=700&seq=centreville-va-hero-001&orientation=landscape",
  heroImageAlt: "Centreville Virginia suburban community with modern neighborhoods, Fair Lakes area, and Northern Virginia Fairfax County landscape",
  geoPosition: "38.8404;-77.4289",
  geoPlacename: "Centreville, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 25 miles east of Centreville via I-66",
  },
  nearbyCitiesZips: [
    { name: "Centreville", zips: "20120, 20121" },
    { name: "Chantilly", zips: "20151, 20152, 20153" },
    { name: "Clifton", zips: "20124" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22034, 22035, 22036, 22037, 22038" },
    { name: "Herndon", zips: "20170, 20171, 20172" },
    { name: "Reston", zips: "20190, 20191, 20192, 20194, 20195, 20598, 22096" },
    { name: "Manassas", zips: "20108, 20109, 20110, 20111, 20112, 20113" },
    { name: "Gainesville", zips: "20155, 20156" },
    { name: "Haymarket", zips: "20169" },
    { name: "Bristow", zips: "20136" },
    { name: "Sterling", zips: "20163, 20164, 20165, 20166, 20167" },
    { name: "Ashburn", zips: "20146, 20147, 20148, 20149" },
    { name: "Leesburg", zips: "20175, 20176, 20177, 20178" },
    { name: "Vienna", zips: "22180, 22181, 22182, 22183, 22185" },
    { name: "Oakton", zips: "22124" },
    { name: "Burke", zips: "22009, 22015" },
    { name: "Springfield", zips: "22150, 22151, 22152, 22153, 22156, 22158, 22159, 22160, 22161" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Fairfax County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Fairfax County Hub", desc: "Serving Centreville, Chantilly, Clifton, and all of Fairfax County" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
    { name: "Chantilly area passport services", route: "/cities/fairfax-va" },
    { name: "Herndon VA passport services", route: "/cities/herndon-va" },
    { name: "Reston VA passport services", route: "/cities/reston-va" },
    { name: "Manassas VA passport services", route: "/cities/manassas-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Centreville remotely via secure courier. We do not have a walk-in office in Centreville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Centreville and Fairfax County travelers.",
  fpcOfficeAddress: "1629 K St NW #300, Washington, DC 20006",
  fpcOfficeDistance: "Serving all of Centreville and Fairfax County including Chantilly, Clifton, Fair Lakes, London Towne, and the greater Centreville area",
  serviceAreaIntro: "From the bustling Fair Lakes shopping district to the quiet streets of London Towne, from the historic Bull Run area to the modern developments of Sully District, from Clifton's rural charm to Chantilly's tech corridor — Fast Passport Center serves every corner of Centreville and Fairfax County. We regularly help travelers from Chantilly, Clifton, Manassas, Gainesville, and Sterling get their passports fast.",
  nearbyCitiesIntro: "We serve all Centreville neighborhoods and Fairfax County including Chantilly, Clifton, Fair Lakes, London Towne, Sully District, Oakton, and the surrounding Northern Virginia communities.",
  howItWorksIntro: "Most Centreville travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Centreville travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Centreville and Fairfax County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Centreville? Here are the most common ones we hear from Fairfax County travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Centreville international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rachel K.",
      location: "Centreville, VA",
      rating: 5,
      text: "I live in the Fair Lakes area and needed an emergency passport for a business trip to Singapore with 5 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Stone Road and it was completely seamless. No need to drive to DC or fight traffic on I-66.",
      service: "Emergency Passport",
    },
    {
      name: "David M.",
      location: "Chantilly, VA",
      rating: 5,
      text: "As a Chantilly resident near the Dulles corridor, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 4 days. The convenience for Fairfax County families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah L.",
      location: "Clifton, VA",
      rating: 5,
      text: "First passports for my three kids before a family trip to Italy. Fast Passport Center handled all the parental consent requirements perfectly and had all three passports in 6 days. For Clifton families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "James T.",
      location: "Centreville, VA",
      rating: 5,
      text: "Lost my passport 2 days before a conference in London. I was in absolute panic. Fast Passport Center had a replacement in my hands in 36 hours. They saved my business trip. Centreville professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "centreville-va-1",
      name: "Centreville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5801 Post Office Rd",
      city: "Centreville",
      state: "VA",
      zip: "20121",
      phone: "(703) 266-2601",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Centreville, near Fair Lakes",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Centreville facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "centreville-va-2",
      name: "Chantilly Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14001 Thunderbolt Pl",
      city: "Chantilly",
      state: "VA",
      zip: "20151",
      phone: "(703) 968-8100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chantilly, east of Centreville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chantilly and eastern Centreville. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "centreville-va-3",
      name: "Fairfax City Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12333 Lee Hwy",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 591-7640",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fairfax, southeast of Centreville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fairfax City and nearby Centreville residents. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "centreville-va-4",
      name: "Manassas Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "13401 Franklin Farm Rd",
      city: "Herndon",
      state: "VA",
      zip: "20171",
      phone: "(703) 481-0730",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Herndon, north of Centreville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Herndon and northern Centreville area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "centreville-va-5",
      name: "Fairfax County Clerk",
      type: "County Clerk",
      address: "4110 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fairfax, county government center",
      website: "https://www.fairfaxcounty.gov/courts/circuit",
      websiteLabel: "Fairfax County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "centreville-va-6",
      name: "Virginia DMV — Centreville",
      type: "DMV Office",
      address: "14900 Stonecroft Center Ct",
      city: "Chantilly",
      state: "VA",
      zip: "20151",
      phone: "(804) 497-7100",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Chantilly, near Centreville",
      website: "https://www.dmv.virginia.gov",
      websiteLabel: "Virginia DMV",
      notes: "Not a passport acceptance facility, but helpful for REAL ID and identification documentation needs.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25+ mile drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Centreville photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Fairfax County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Centreville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Centreville families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Centreville travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Centreville or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Centreville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Centreville before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Centreville for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from Fairfax County." },
    { q: "How fast can I renew my passport in Centreville?", a: "Fast Passport Center offers fast passport renewal in Centreville in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Centreville?", a: "The nearest regional passport agency to Centreville is the Washington Passport Agency, located approximately 25 miles east in downtown Washington, DC. For urgent processing without fighting I-66 traffic and DC parking, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Centreville." },
    { q: "Can I get a same-day passport appointment near Centreville?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Centreville residents." },
    { q: "Can I expedite a child passport in Centreville?", a: "Yes. Fast Passport Center expedites child passports in Centreville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Fairfax County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Centreville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Centreville?", a: "With Fast Passport Center's emergency courier service, Centreville travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Centreville?", a: "Popular options include the Centreville Post Office (20121), Chantilly Post Office (20151), Fairfax City Main Post Office (22030), and Herndon Post Office (20171). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Chantilly, Clifton, or Fair Lakes?", a: "We serve the entire Fairfax County area including Chantilly, Clifton, Fair Lakes, London Towne, Sully District, and all surrounding communities. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Centreville?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Centreville", address: "14125 Saint Germain Dr, Centreville, VA 20121", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Centreville", address: "14245 Lee Hwy, Centreville, VA 20121", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Centreville", address: "5635 Stone Rd, Centreville, VA 20120", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Chantilly", address: "14110 Lee Hwy, Chantilly, VA 20151", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Chantilly", address: "14511 Lee Jackson Memorial Hwy, Chantilly, VA 20151", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Fairfax", address: "10430 Fairfax Blvd, Fairfax, VA 22030", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Centreville",
      address: "14900 Stonecroft Center Ct, Chantilly, VA 20151",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Fairfax",
      address: "4170 Merchants Plaza, Fairfax, VA 22033",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Manassas",
      address: "9417 West St, Manassas, VA 20110",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Prince William County and nearby Fairfax County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 12 miles north of Centreville",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The closest international airport to Centreville. Major hub for international flights to Europe, Asia, and the Middle East. Accessible via VA-28 and the Dulles Toll Road.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National Airport",
      distance: "Approximately 22 miles east of Centreville",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Domestic hub with limited international service. Accessible via I-66 and the George Washington Memorial Parkway.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International",
      distance: "Approximately 55 miles northeast of Centreville",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Southwest hub and international gateway. Accessible via I-66 and I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};